module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/444daa86d2f977903edf6799e8083602.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Emerald/Emerald0.svg
// module id = smAp
// module chunks = 1